var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.importFailed && _vm.requiresFullImport)?_c('import-failed-modal'):_c('loading',{attrs:{"textColor":"blue","progress":_vm.overallProgress}})
}
var staticRenderFns = []

export { render, staticRenderFns }